import React from "react"
const style1 = {
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: "10",
  strokeWidth: "0.8px",
}
const Headset = () => {
  return (
    <svg viewBox="0 0 16.8 18.8">
      <g id="Group_4" transform="translate(0.4 0.4)">
        <path
          id="Path"
          style={style1}
          d="M0,4.2S3.429,4.2,3.429,0"
          transform="translate(10.286 12.6)"
        />
        <path
          id="Path-2"
          style={style1}
          d="M0,7.2V6C0,2.7,2.286,0,5.429,0H6c3.143,0,5.429,2.7,5.429,6V7.2"
          transform="translate(2.286)"
        />
        <path
          id="Shape"
          style={style1}
          d="M14.972,5.4h-2.4V0h2.4A1.056,1.056,0,0,1,16,1.08V4.32A1.056,1.056,0,0,1,14.972,5.4ZM3.429,5.4h-2.4A1.056,1.056,0,0,1,0,4.32V1.08A1.056,1.056,0,0,1,1.029,0h2.4V5.4Z"
          transform="translate(0 7.2)"
        />
        <path
          id="Shape-2"
          style={style1}
          d="M3.429,1.2A1.172,1.172,0,0,0,2.286,0H1.143A1.172,1.172,0,0,0,0,1.2,1.172,1.172,0,0,0,1.143,2.4H2.286A1.172,1.172,0,0,0,3.429,1.2Z"
          transform="translate(6.857 15.6)"
        />
      </g>
    </svg>
  )
}

export default Headset
